<div class="c-content c-content--wrapper u-no-p" [ngStyle]="vm.loading && {'min-height': '300px'}">
    <p id="addEmployeesToSurveyTitle" style="padding:10px;" class="c-text c-text--lg c-text--sm@up-to-md c-text--bold c-text--main">
        {{ 'Employees.Select_Employees_Title' | translate }}
    </p>
    <div *ngIf="!vm.loading">
        <form class="c-form">
	        <div class="c-content u-no-ph@md-and-up ">
	            <div class="o-grid o-grid--center-v o-grid--wrap" style="margin-top: 10px;">
	                <div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-60@md-and-up u-no-p o-grid__cell--left">
	                    <div class="o-grid">
	                        <div class="o-grid__cell o-grid__cell--slim">
	                            <div class="c-form__group u-osb-sm">
	                                <label class="c-checkbox">
	                                    <input id="showActivatedEmployees" 
	                                    	name="showActivatedEmployees"
	                                    	(change)="vm.showActiveOnly()"
	                                        type="checkbox"
	                                        [(ngModel)]="vm.isShowActiveOnly">
	                                    <span id="showActivatedEmployeesLabel">
	                                        {{ 'Employees.Show_Activated_Employees' | translate }}
	                                    </span>
	                                </label>
	                            </div>
	                        </div>
	                    </div>
	                </div>
	                <div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-25@md-and-up u-no-p o-grid__cell--right">
	                    <div class="o-grid">
	                        <div class="o-grid__cell o-grid__cell--slim">
	                            <div class="c-form__group c-form__group--icon u-osb-sm">
	                                <i class="o-icon o-icon--search c-form__icon" style="top: 50%"
	                                   aria-hidden="true"></i>
	                                <input 
	                                	id="searchEmployeeInput" 
	                                	name="searchEmployeeInput"
	                                	type="text"
	                                    class="c-form__input c-form__input--sm" spellcheck="false"
	                                    placeholder="{{ 'Employees.Search_Employee_Placeholder' | translate }}"
	                                    [(ngModel)]="vm.term"
	                                    (ngModelChange)="onSearchChange($event)">
	                            </div>
	                        </div>
	                    </div>
	                </div>
	                <div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-15@md-and-up u-no-p o-grid__cell--right">
	                    <div class="o-grid">
	                        <div class="o-grid__cell o-grid__cell--slim u-osb-sm">
	                            <a id="continueButton" class="c-button c-button--s1 c-button--fit"
	                               (click)="vm.openModalSurveyDialog()">
	                                {{ 'Employees.Continue' | translate }}
	                            </a>
	                        </div>
	                    </div>
	                </div>
	            </div>
	        </div>
        </form>
        <div class="c-content c-content--border-bottom u-no-ph@md-and-up u-hidden@up-to-md">
            <div class="o-grid o-grid--wrap">
                <div class="o-grid__cell o-grid__cell--w-5 u-no-p" style="margin-left: 5px;margin-right:-5px;">
                    <label *ngIf="!vm.term || vm.term?.trim().length === 0" for="selectAllEmployees" class="c-checkbox">
                        <!-- isAllEmployeesModeEnabled -->
                        <input id="selectAllEmployees" 
                        	name="selectAllEmployees" 
                        	type="checkbox"
                        	(change)="vm.updateAllEmployeesModeEnabled()" 
                            [(ngModel)]="vm.isAllEmployeesModeEnabled">
                        <span id="selectAllEmployeesLabel"></span>
                    </label>
                </div>
                <div class="o-grid__cell o-grid__cell--w-30 u-no-p">
                    <a id="nameFilterLink" href="javascript:void(0);" class="c-text c-text--gray" (click)="vm.setFilter('name')"
                       aria-hidden="true"><span style="vertical-align:middle">{{ 'Employees.Name' | translate }}</span>&nbsp;<span
                            *ngIf="vm.filter.orderBy==='name' && vm.filter.ascending">&#8595;</span><span
                            *ngIf="vm.filter.orderBy==='name' && !vm.filter.ascending">&#8593;</span></a>
                </div>
                <div class="o-grid__cell o-grid__cell--w-30 u-no-p">
                    <a id="emailFilterLink" href="javascript:void(0);" class="c-text c-text--gray" (click)="vm.setFilter('email')"
                       aria-hidden="true"><span style="vertical-align:middle">{{ 'Employees.Email' | translate }}</span>&nbsp;<span
                            *ngIf="vm.filter.orderBy==='email' && vm.filter.ascending">&#8595;</span><span
                            *ngIf="vm.filter.orderBy==='email' && !vm.filter.ascending">&#8593;</span></a>
                </div>
                <div class="o-grid__cell o-grid__cell--w-15 u-no-p">
                    <span class="c-text c-text--gray"
                          style="vertical-align:middle">
                        {{ 'Employees.Status' | translate }}
                    </span>
                </div>
                <div class="o-grid__cell o-grid__cell--w-20 u-no-p">
                    <span class="c-text c-text--gray" style="vertical-align:middle">
                        {{ 'Employees.Placeholder.AdditionalInfoShort' | translate }}
                    </span>
                </div>
            </div>
        </div>
        <ul class="c-list">
			<li *ngFor="let employee of vm.employees | startFrom:vm.currentPage*vm.pageSize | arrayLimitTo:vm.pageSize ; let $index=index">
                <div class="c-content c-content--border-bottom u-no-ph@md-and-up" [hidden]="employee.deleted">
                    <div id="employee-action-element-{{employee.id}}" class="o-grid o-grid--wrap@up-to-md">
                        <div class="o-grid__cell o-grid__cell--w-10 o-grid__cell--w-5@md-and-up u-no-p" style="margin-left: 5px;margin-right:-5px;margin-top:-4px;">
                            <label class="c-checkbox">
                                <input id="selectedEmployees{{$index}}" 
                                    name="selectedEmployees{{$index}}"
                                    [(ngModel)]="vm.employeeSelectionMap[employee.id]"
                                    type="checkbox">
                                <span id="selectedEmployeesLabel{{$index}}"></span>
                            </label>
                        </div>
                        <div class="o-grid__cell o-grid__cell--w-90 o-grid__cell--w-30@md-and-up u-no-p o-grid__cell--o1@md-and-up u-osb-md@up-to-md">
                            <p class="c-text">
                            	<label for="selectedEmployees{{$index}}">{{ employee.firstName }} {{ employee.lastName }}</label>
                            	<span class="u-hidden@up-to-md" *ngIf="employee.personalCode"> {{ '(' + employee.personalCode + ')' }}</span>
                            </p>
                        </div>
                        <div class="o-grid__cell o-grid__cell--w-100 u-hidden@md-and-up u-no-p u-ost-md@up-to-md" *ngIf="employee.personalCode">
                           	<span class="u-hidden@md-and-up">{{ 'Employees.Personal_Code' | translate }}: </span>
                            <p class="c-text c-text--sm">
                            	<span class="c-text--s10">{{ employee.personalCode }}</span>
                            </p>
                        </div>
                        <div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-30@md-and-up u-no-p o-grid__cell--o1@md-and-up u-ost-md@up-to-md">
                           	<span class="u-hidden@md-and-up">{{ 'Employees.Email' | translate }}: </span>
                            <p id="employeeEmail{{$index}}" style="word-break: break-all;padding-right:10px;" class="c-text c-text--sm@up-to-md">
                                <span class="c-text--s10">{{ employee.email }}</span>
                            </p>
                        </div>
                        <div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-15@md-and-up u-no-p o-grid__cell--o1@md-and-up u-ost-md@up-to-md">
                           	<span class="u-hidden@md-and-up">{{ 'Employees.Status' | translate }}: </span>
                            <p class="c-text c-text--sm@up-to-md">
                                <span class="c-text--s10">{{ vm.getEmployeeStatus(employee) }}</span>
                            </p>
                        </div>
                        <div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-20@md-and-up u-no-p o-grid__cell--o1@md-and-up u-ost-md@up-to-md">
                            <span class="u-hidden@md-and-up" *ngIf="employee.additionalInfo || employee.additionalInfo2">{{ 'Employees.Placeholder.AdditionalInfoShort' | translate }}: </span>
                            <p id="employeeAdditionalInfo{{$index}}" style="word-break: break-all;" class="c-text c-text--sm@up-to-md">
                                <span class="c-text--s10">
                                	{{ employee.additionalInfo }}<ng-container *ngIf="employee.additionalInfo">, </ng-container>{{ employee.additionalInfo2 }}
                                </span>
                            </p>
                        </div>
                    </div>
                </div>
            </li>
        </ul>
        <item-no-content *ngIf="!vm.employees?.length"></item-no-content>
    </div>
    <loader-overlay *ngIf="vm.loading"></loader-overlay>
</div>